import React from 'react';
import uploadAttachmentHandler from './UploadAttachmentHandler';

/**
 * Single thumbnail row in the upload file list.
 * Shows image preview or file icon, file name, size, provider and remove button.
 * Locked during upload — no remove, no select.
 * @param {UploadFileItem} item
 * @param {number} index
 * @param {boolean} selected
 * @param {boolean} locked
 */
export default function UploadFileThumbnail({ item, index, selected, locked }) {

    /**
     * Selects this thumbnail — ignored when locked.
     */
    const handleSelect = () => {
        if (locked) return;
        uploadAttachmentHandler.dispatch('onFileSelected', { index });
    };

    /**
     * Removes this file from the list — ignored when locked.
     * Stops propagation to prevent triggering handleSelect.
     * @param {React.MouseEvent} e
     */
    const handleRemove = (e) => {
        e.stopPropagation();
        if (locked) return;
        uploadAttachmentHandler.dispatch('onFileRemoved', { index });
    };

    // Format size as MB (1 decimal) if >= 1024 KB, otherwise as KB
    const sizeLabel = item.size >= 1024
        ? `${(item.size / 1024).toFixed(1)} MB`
        : `${item.size} KB`;

    return (
        <div
            id={`upload-thumb-row-${index}`}
            className={`upload-thumb-row ${selected ? 'selected' : ''} ${locked ? 'locked' : ''}`}
            onClick={handleSelect}
        >
            {/* Image preview or file icon */}
            <div className="upload-thumb-icon">
                {item.previewUrl
                    ? <img src={item.previewUrl} alt={item.fileName} />
                    : <span className="upload-thumb-file-icon">📄</span>
                }
            </div>

            <div className="upload-thumb-meta">
                <div className="upload-thumb-name">{item.fileName}</div>
                {/* Size on first sub line, provider on second line with ellipsis */}
                <div className="upload-thumb-size">{sizeLabel}</div>
                <div className="upload-thumb-provider">{item.provider}</div>
            </div>

            {!locked && (
                <button
                    className="upload-thumb-remove"
                    onClick={handleRemove}
                    aria-label={`Remove ${item.fileName}`}
                >
                    ✕
                </button>
            )}
        </div>
    );
}
